import * as React from 'react';
import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ShareIcon from '@mui/icons-material/Share';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SwipeableTextMobileStepper from './SwipeableTextMobileStepper';
import {
  useParams
} from "react-router-dom";

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));

export default function Product() {
  const [expanded, setExpanded] = React.useState(true);
  let { name } = useParams();
  console.log(name);
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <Card>
      {/* <CardHeader
        // title='Máscara del lider de "El juego del calamar"'
        // subheader="September 14, 2016"
      /> */}
      <CardMedia>
        <SwipeableTextMobileStepper/>
      </CardMedia>

      <CardContent>
        <Typography variant="body2" color="text.secondary">
          Mascara del lider "El juego del calamar"
        </Typography>
      </CardContent>
      <CardActions disableSpacing>
        {/* <IconButton aria-label="add to favorites">
          <FavoriteIcon />
        </IconButton> */}
        <IconButton aria-label="share">
          <ShareIcon />
        </IconButton>
        <ExpandMore
          expand={expanded}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <ExpandMoreIcon />
        </ExpandMore>
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
          <Typography paragraph>Precio: $400</Typography>
          <Typography paragraph>
            Envío gratis a todo México (asegurate de poner tu direccion correcta al momento de pagar)
          </Typography>
          <Typography paragraph>
            Medidas: 16.5cm x 22cm 
          </Typography>
          <div id="smart-button-container">
            <div>
              <div id="paypal-button-container"></div>
            </div>
          </div>
        </CardContent>
      </Collapse>
    </Card>
  );
}